export default "__VITE_ASSET__98ce2caf__"